import React from "react";
import { Chip } from "@mui/material";

const StatusChip = ({ status }) => {
  const getColor = () => {
    switch (status) {
      case "Created":
        return "info";
      case "Open":
        return "success";
      case "Started":
        return "primary";
      case "Running":
        return "primary";
      case "Closed":
        return "secondary";
      default:
        return "white";
    }
  };

  return (
    <Chip label={status} color={getColor()} variant="outlined" size="small" />
  );
};

export default StatusChip;
